import type { ReactNode } from 'react'

interface TableToolbarProps {
  dark: boolean
  left: ReactNode
  right?: ReactNode
}

/**
 * Consistent toolbar row inside a table card.
 * Left slot: row count / summary label.
 * Right slot: sort controls, export button, or any actions.
 *
 * Mobile (<768px): stacks left/right vertically.
 * md+: single row with justify-between.
 */
export function TableToolbar({ dark, left, right }: TableToolbarProps) {
  return (
    <div className={`flex flex-col gap-2 px-4 py-2.5 border-b md:flex-row md:items-center md:justify-between md:gap-4 ${
      dark ? 'border-white/6' : 'border-slate-100'
    }`}>
      <div className="flex items-center min-w-0">{left}</div>
      {right && <div className="flex items-center gap-2 flex-wrap">{right}</div>}
    </div>
  )
}
